import { Injectable } from '@angular/core';
import { SemiAutoImportHttpService, RawMaterialSemiautoRequestDto, RawMaterialSemiautoResponseDto } from '@sharedcommon/rest/data.restservice';
import { UserService } from '@sharedcommon/services/user.service';
import { lastValueFrom } from 'rxjs';

@Injectable()
export class ImportSemiAutoService {
  fileName: string;
  constructor(private readonly httpService: SemiAutoImportHttpService, private readonly userService: UserService) { }

  async loadFile(file: File): Promise<string> {
    this.fileName = file.name;
    const reader = new FileReader();
    const fileContentPromise = new Promise<string>((resolve, reject) => {
      reader.onload = () => {
        resolve(reader.result as string);
      };
      reader.onerror = () => {
        reject(reader.error);
      };
    });
    reader.readAsText(file);
    return fileContentPromise;
  }

  async parseCsvFile(file: File, isCreation: boolean): Promise<RawMaterialSemiautoResponseDto> {

    const fileContent = await this.loadFile(file);
    const body: RawMaterialSemiautoRequestDto = new RawMaterialSemiautoRequestDto();
    body.csvContent = fileContent;
    let response: RawMaterialSemiautoResponseDto;
    if (isCreation) {
      response = await lastValueFrom(this.httpService.importRmFeedSemiAutoCreation(this.userService.getEntity(), body));
    } else {
      response = await lastValueFrom(this.httpService.importRmFeedSemiAutoModification(this.userService.getEntity(), body));
    }
    return response;
  }
}
